import { AxiosResponse } from "axios";
import { call, put } from "redux-saga/effects";
import api from "../../Axios/middleware";
import {
  failureaddSubscribedMap,
  successaddSubscribedMap,
} from "./AddSubscribedMapSlice";
import { PayloadAction } from "@reduxjs/toolkit";
import { ISubscribedMap } from "../../../Pages/SubscribedMap/ISubscribed";

import {
  failuredeleteSubscribedMap,
  successdeleteSubscribedMap,
} from "./DeleteSubscribedMapSlice";
import {
  failurelistSubscribedMap,
  successlistSubscribedMap,
} from "./ListSubscribedMapSlice";
import {
  failureEditSubscribedMap,
  successEditSubscribedMap,
} from "./EditSubscribedMapSlice";

// list
const ListSubscribedMapApi = () => {
  return api.get("/api/packagefreesubdata");
};

export function* ListSubscribedMapCall() {
  try {
    const response: AxiosResponse = yield call(ListSubscribedMapApi);
    yield put(successlistSubscribedMap(response.data));
  } catch (error) {
    yield put(failurelistSubscribedMap(error));
  }
}

// add
const AddSubscribedMapApi = (action: PayloadAction<ISubscribedMap>) => {
  return api.post("/api/packagefreeSubscription", action.payload);
};

export function* AddSubscribedMapCall(action: PayloadAction<ISubscribedMap>) {
  try {
    const response: AxiosResponse = yield call(AddSubscribedMapApi, action);
    yield put(successaddSubscribedMap(response.data));
  } catch (error) {
    yield put(failureaddSubscribedMap(error));
  }
}

// edit
const EditSubscribedMapApi = (action: PayloadAction<ISubscribedMap>) => {
  return api.put("/api/packagefreesubdata", action.payload, {
    params: { id: action.payload.id },
  });
};

export function* EditSubscribedMapCall(action: PayloadAction<ISubscribedMap>) {
  try {
    const response: AxiosResponse = yield call(EditSubscribedMapApi, action);
    yield put(successEditSubscribedMap(response.data));
  } catch (error) {
    yield put(failureEditSubscribedMap(error));
  }
}

// delete
const DeleteSubscribedMapApi = (action: PayloadAction<number>) => {
  return api.delete("/api/packagedelfreesub", {
    params: { id: action.payload },
  });
};

export function* DeleteSubscribedMapCall(action: PayloadAction<number>) {
  try {
    const response: AxiosResponse = yield call(DeleteSubscribedMapApi, action);
    yield put(successdeleteSubscribedMap(response.data));
  } catch (error) {
    yield put(failuredeleteSubscribedMap(error));
  }
}
